var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeselect = function SvgDeselect(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5810"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5804",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#63849f",
    "data-name": "Rechteck 391",
    rx: 2,
    transform: "translate(0 -20)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M4.038-12.5h6.923",
    "data-name": "Linie 711"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeselect);
export default ForwardRef;